var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 60,
    viewBox: "0 0 163 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5759 30.4879C58.5759 37.937 52.5371 43.9758 45.088 43.9758C37.6388 43.9758 31.6001 37.937 31.6001 30.4879C31.6001 23.0387 37.6388 17 45.088 17C52.5371 17 58.5759 23.0387 58.5759 30.4879ZM41.7263 22.7553C42.7544 22.3083 43.8897 22.058 45.0876 22.058C49.7452 22.058 53.5178 25.8305 53.5178 30.497C53.5178 31.6681 53.2764 32.7856 52.8473 33.7958L43.7288 29.9249H49.4413C49.1641 27.7615 47.3225 26.0987 45.0876 26.0987C44.6317 26.0987 44.1847 26.1613 43.7735 26.2954L41.7263 22.7553ZM40.6988 30.4969C40.6988 32.9196 42.6655 34.8863 45.0882 34.8863C45.419 34.8863 45.7408 34.8416 46.0447 34.779L48.1545 38.346C47.2069 38.7125 46.1699 38.9181 45.0882 38.9181C40.4306 38.9181 36.6581 35.1455 36.6581 30.488C36.6581 29.4331 36.8547 28.4229 37.2034 27.4932L40.9223 29.1202C40.7793 29.5582 40.6988 30.0142 40.6988 30.4969Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2724 39.3393H65.8467V21.0042H70.2724L75.7518 30.4879L81.0205 21.0042H85.3409V39.3393H81.0205V29.118L76.9109 36.3888H74.4873L70.2724 29.118V39.3393Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.779 21.0042H88.6075V39.3393H101.779V35.5458H92.9278V31.7524H100.515V28.1697H92.9278V24.6923H101.779V21.0042Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.781 21.0042H107.786L114.213 34.0706L115.689 30.2771L111.263 21.0042H115.267L117.585 25.3246L119.271 21.0042H123.908L120.009 30.2771L121.906 34.0706L126.858 21.0042H131.6L123.908 39.3393H120.009L118.112 35.1243L116.215 39.3393H112.633L103.781 21.0042Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMew);
export default __webpack_public_path__ + "static/media/mew.abd579786274219a78079f023ed7b335.svg";
export { ForwardRef as ReactComponent };